import React from 'react';
import { Link } from 'react-router-dom';

const Support = () => {
  return (
    <div className="bg-[#f1f0ee] font-semibold text-[#1f1f1f] font-serif min-h-screen flex flex-col justify-between overflow-x-hidden">

      {/* Grid background */}
      <div
        className="pointer-events-none absolute inset-0 z-0"
        style={{
          backgroundImage: `
              linear-gradient(to right, #ddd 1px, transparent 1px),
              linear-gradient(to bottom, #ddd 1px, transparent 1px)
            `,
          backgroundSize: "32px 32px",
          opacity: 1,
          maskImage: "radial-gradient(circle at center, white, transparent 75%)",
          WebkitMaskImage: "radial-gradient(circle at center, white, transparent 75%)"
        }}
        aria-hidden="true"
      />

      {/* Top bar */}
      <div className="bg-white/50 shadow-lg h-14 md:h-16 md:w-full max-w-[1000px] z-30 mt-3 md:m-4 md:mx-auto px-3 md:px-4 border border-[#383838]/20 rounded-2xl md:rounded-3xl mx-3">
        <div className="flex h-full items-center justify-between">
          <Link to="/" className="min-w-0">
            <div className="flex items-center">
              <img src="images/lrc_icon.png" alt="LearnRussianCases icon" className="w-7 h-7 md:w-8 md:h-8 rounded-full mr-2" />
              <p className="text-[#1f1f1f] font-nunito text-lg md:text-2xl truncate">LearnRussianCases</p>
            </div>
          </Link>

          <div className="flex flex-row gap-x-4 md:gap-x-8">
            <Link to="/support"><p className="text-[#1f1f1f] font-nunito text-sm md:text-lg">Support</p></Link>
            <Link to="/privacy"><p className="text-[#1f1f1f] font-nunito text-sm md:text-lg">Privacy</p></Link>
          </div>
        </div>
      </div>

      {/* Headline */}
      <div className="mt-6 md:mt-8 mx-auto z-30 w-full md:w-auto max-w-[1000px] px-4">
        <h1 className="font-bebas tracking-wide mb-6 md:mb-0 text-7xl md:text-8xl text-center md:text-left leading-none">
          Support
        </h1>
      </div>

      {/* Main content */}
      <main id="seo-content" className="z-30 w-full mt-6 md:mt-10">
        {/* HOW CAN WE HELP? */}
        <section id="how-can-we-help" aria-labelledby="how-can-we-help-title" className="m-4 md:m-0">
          <h2
            id="how-can-we-help-title"
            className="font-bebas text-4xl md:text-5xl w-full md:w-[1000px] mx-auto tracking-wide mb-3 md:mb-4 md:pl-8 text-center md:text-left"
          >
            How can we help?
          </h2>

          <div className="relative bg-white/50 shadow-lg w-full md:w-[1000px] z-30 m-4 mx-auto p-6 border border-[#383838]/20 rounded-3xl">
            <img
              src="images/doll_head_smiling.png"
              alt="Smiling matryoshka doll"
              className="hidden md:block absolute w-24 h-24 -top-24 right-8"
            />

            <p className="font-nunito leading-7">
              If you have any questions, feature requests, or need help using the LearnRussianCases app, please email us at{' '}
              <a
                className="underline decoration-[#1f1f1f]/50"
                href="mailto:learnrussiancases@gmail.com"
                itemProp="email"
              >
                learnrussiancases@gmail.com
              </a>.
            </p>
          </div>
        </section>
      </main>

      <div className='flex-1'></div>

      {/* Footer */}
      <footer className="bg-white/50 shadow-lg h-14 md:h-16 md:w-full max-w-[1000px] z-30 mx-3 md:m-4 mb-4 md:mb-8 md:mx-auto px-4 border border-[#383838]/20 rounded-2xl md:rounded-3xl">
        <div className="flex h-full items-center justify-center">
          <a href="https://josephmalam.com/" target="_blank" className="font-nunito px-2 text-sm md:text-base" rel="noopener noreferrer">
            &copy; <span className='underline decoration-[#1f1f1f]/50'>Joseph</span> and Anna Malam 2022-2025
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Support;
